(function ($) {
  $(window).on("load", function () {
    const popUp = $(".subscribe-popup");
    const closePopUpBtn = popUp.find(".close-btn");
    let hasClosedPopUp = false;
    const halfPageHeight = document.documentElement.scrollHeight / 2;

    function handleScroll() {
      if (!hasClosedPopUp) {
        if (window.scrollY >= halfPageHeight) {
          popUp.addClass("show-pop-up");
        }
      }
    }

    function closePopUp() {
      popUp.removeClass("show-pop-up");
      hasClosedPopUp = true; // Ensure the pop-up doesn't reappear after being closed
    }

    $(window).on("scroll", handleScroll);
    closePopUpBtn.on("click", closePopUp);
  });
})(jQuery);
